import React, { useEffect, useState }from 'react';

import PropTypes from 'prop-types';

import { NavTopMenu } from '../shared/NavTopMenu';
import { Footer } from '../shared/Footer';
import { SidebarMenu } from '../shared/SidebarMenu';

import '../../styles/style.scss';
import '../../styles/createRolStyle.scss';

import {
  TextField,
  Typography,
} from '@material-ui/core';

import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import Swal from 'sweetalert2';
import { actionErrorConnection } from '../../constants/component/actionErrorConnection';
import { sesionExpired } from '../../constants/auth/sesionExpired';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { timeSessionDifference } from '../../constants/auth/timeSessionDifference';
import UserService from "../../services/users.service";
import { useForm } from 'react-hook-form';

export const CreateCustomerScreen = (props) => {

  const { isLoggedIn, user:userLogged } = useSelector(state => state.auth);
  const noCustomer = isLoggedIn? userLogged.noCustomer:'';

  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const tokenExpired = process.env.REACT_APP_TIME_EXPIRED_TOKEN;
  const sessionDifference = timeSessionDifference();

  const customerUpdate = props.match.params.id;

  const initialState = {
    name: '',
    mail: ''

  }

  const [customer, setCustomer] = useState(initialState);
  const [isDisabled, setDisabled] = useState(false);

  const swalCustomButtons = Swal.mixin({
    customClass: {
      confirmButton: 'btn custom-btn',
      cancelButton: 'btn custom-cancel-btn me-3'
    },
    buttonsStyling: false
  });

  const regexCode = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Nombre es requerido').matches(/^[A-Z\s]+$/, 'Solo se admiten letras'),
    mail: Yup.string().required('Correo es requerido').matches(regexCode, "Formato de correo no válido")
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: customer
  });

  useEffect(() => {
    if(customerUpdate){
      const customerActived = location.state.customer;
      getCustomer(customerActived);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

    /** 
   * Recupera la información del usuario para precargar el formulario de actualización
   * @author alSanchez - ETE
   * @version 1.0.0 - Noviembre 2023
  */
    const getCustomer = (customerActived) => {
      const customerUpdate = {
        ...customer,
        mail: customerActived.mail,
        name: customerActived.name
      }
      setCustomer(customerUpdate);
      reset(customerUpdate)
    }

  /**
   * Cancela el llenado de información dentro del formulario y regresa a la pantalla de roles
   * @author alSanchez - ETE
   * @version 1.0.0 - Septiembre 2023
   */
  const handleCancel = () => {
    swalCustomButtons.fire({
      title: 'Cancelar',
      text: "Esta acción eliminará toda información no guardada.",
      icon: 'warning',
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        props.history.push('/administration/users');
        window.location.reload();
      }
    })
  }

    /**
   * Cambia los datos del formulario de acuerdo a la entrada seleccionada
   * @param {*} event - recupera información del imput seleccionado
   * @param {string} input - nombre de la entrada
   * @author alSanchez - ETE
   * @version 1.0.0 - Noviembre 2023
   */
    const handleChangeValue =(event, input) =>{
      const value = event.target.value.toUpperCase();
      setCustomer({...customer, [input]: value});
      reset({...customer, [input]: value});
    }

  /**
   * Envia el formulario de registro
   * @param {object} data - informacion del formulario
   * @author alSanchez - ETE
   * @version 1.0.0 - octubre 2023
   */
  const onSubmit = (data) => {
    setDisabled(true);
    const customerDataToSend = {
      name: data.name,
      mail: data.mail
  }
  
  if(customerUpdate){
    updateCustomer(customerDataToSend);
  } else{
    createCustomer(customerDataToSend);
  }
  };

  /**
   * Solicita registro de un usuario
   * @param {object} dataCustomer - información de registro
   * @author alSanchez - ETE
   * @version 1.0.0 - Noviembre 2023
   */
  const createCustomer = (dataCustomer) =>{
    UserService.createCustomer(dataCustomer, noCustomer).then((response)=>{
      if(response.length > 1){
        Swal.fire({
          icon: 'error',
          title: 'Representante no registrado',
          html:`${response}`,
          showConfirmButton: true,
          confirmButtonText: 'Aceptar'
        });

      } else{
        Swal.fire({
          icon: 'success',
          title: 'Representante registrado exitosamente',
          showConfirmButton: true,
          confirmButtonText: 'Regresar'
        })
        .then(() => {
          props.history.push('/administration/users');
          window.location.reload();
        }); 
      }
      setDisabled(false);   
    }).catch((error)=>{
      setDisabled(false);
      if(sessionDifference > Number(tokenExpired)){
          sesionExpired(dispatch, history);
        } else{
          actionErrorConnection(error, 'Error al registrar Representante.');
        }
    });
  }

    /**
   * Solicita registro de un usuario
   * @param {object} dataCustomer - información de registro
   * @author alSanchez - ETE
   * @version 1.0.0 - Octubre 2023
   */
    const updateCustomer = (dataCustomer) =>{
      UserService.updateCustomer(dataCustomer, customerUpdate, noCustomer ).then((response)=>{
        if(response.length > 1){
          Swal.fire({
            icon: 'error',
            title: 'Representante no actualizado',
            html:`${response}`,
            showConfirmButton: true,
            confirmButtonText: 'Aceptar'
          });
  
        } else{
          Swal.fire({
            icon: 'success',
            title: 'Representante actualizado exitosamente',
            showConfirmButton: true,
            confirmButtonText: 'Regresar'
          })
          .then(() => {
            props.history.push('/administration/users');
            window.location.reload();
          }); 
        }
        setDisabled(false);   
      }).catch((error)=>{
        setDisabled(false);
        if(sessionDifference > Number(tokenExpired)){
            sesionExpired(dispatch, history);
          } else{
            actionErrorConnection(error, 'Error al actualizar Representante.');
          }
      });
    }

    return (
        <>
          <div className="container-fluid p-0 m-0">
            <div className="row flex-nowrap p-0 m-0">
                <div className="col-auto col-md-3 col-xl-2 p-0 d-none d-sm-block">
                <SidebarMenu/>
                </div>
                <div className="col p-0 ms-1 me-1">
                <NavTopMenu />
                <div className="container ps-3 pe-3 container-size">
                  <div className="row base-container ">
                    <div>
                    <div className="col-12 border-title text-title pt-2 pb-2 ps-4 h4">
                      <span>Representantes</span>
                      <i className="fas fa-angle-right ms-2 me-2"></i>
                      <span>{`${customerUpdate ? 'Actualizar' : 'Registrar'} representante`}</span>
                    </div>
                    <div className="col-12 pt-3 pb-3 ps-4 pe-4">
                      <form>
                        <div className="container p-0">
                          <div className="row ">
                            <div className="col-md-3">
                              <div className="border-text-menu-title">
                                <span className="text-subtitle" >Información general</span>
                              </div>
                            </div>
                            <div className="col-md-9 pt-5 pb-2">
                              <div className="row">
                                <div className="col-md-6 mt-2 mb-2">
                                  <TextField
                                    required
                                    className="w-100"
                                    id="name"
                                    name="name"
                                    label="Nombre de representante"
                                    type="text"
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    value={customer.name}
                                    {...register('name')}
                                    onChange={event => handleChangeValue(event, 'name')}
                                    error={errors.name ? true : false}
                                  />
                                  <Typography variant="inherit" color="error">
                                      {errors.name?.message}
                                  </Typography>
                                </div>
                                <div className="col-md-6 mt-2 mb-2">
                                  <TextField
                                    required
                                    className="w-100"
                                    id="mail"
                                    name="mail"
                                    label="Correo"
                                    type="text"
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    value={customer.mail}
                                    {...register('mail')}
                                    onChange={event => handleChangeValue(event, 'mail')}
                                    error={errors.mail ? true : false}
                                  />
                                  <Typography variant="inherit" color="error">
                                      {errors.mail?.message}
                                  </Typography>
                                </div>
                              </div> 
                            </div>
                          </div>
                          <div className="d-flex flex-row-reverse ">
                            <div className="col-md-9 d-flex flex-row-reverse border-button-actions mt-2 pt-2">
                              <button  
                              className="btn custom-btn pt-2 pb-2 ps-3 pe-3" 
                              onClick={handleSubmit(onSubmit)}
                              disabled={ isDisabled }>
                                       {`${customerUpdate ? 'Actualizar' : 'Registrar'}`} { isDisabled && <i className="fas fa-spinner fa-spin"></i>}
                              </button>
                              <button  
                              className="btn custom-cancel-btn pt-2 pb-2 ps-3 pe-3 me-3"
                              type="button" 
                              onClick={handleCancel}>
                                    Cancelar
                              </button>
                            </div>
                          </div>
                          
                        </div>
                      </form>
                    </div>
                      
                    </div>

                  </div>
                </div>

                </div>
            </div>
          </div>
        
           
            <Footer/>
        </>
    )
}

CreateCustomerScreen.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string
    })
  }),
  history: PropTypes.object
}